import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=48ef7a48&scoped=true&"
import script from "./Estoque.vue?vue&type=script&lang=js&"
export * from "./Estoque.vue?vue&type=script&lang=js&"
import style0 from "./Estoque.vue?vue&type=style&index=0&id=48ef7a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef7a48",
  null
  
)

export default component.exports